<template>
  <div class="invoice-book container">
    <a-page-header class="header" title="电子发票" />
    <a-spin class="loading" v-if="loading" size="large"></a-spin>
    <div v-else>
      <div class="invoice-book-flight">
        <a-table
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="list"
          row-key="index"
          :pagination="false"
        >
          <span slot="orderAmount" slot-scope="text">￥{{ text }}</span>
          <span slot="action" slot-scope="text, record">
            <span class="link" v-if="record.invoiceStatusName === '可开具'" @click="goThirdUrl(record.invoiceUrl)">开具发票</span>
            <span v-else>-</span>
          </span>
          <router-link slot="orderDetail" slot-scope="text, record" :to="detailLink(record)" target="_blank">详情</router-link>
        </a-table>
      </div>
      <div class="mod-action" v-if="!['Y8'].includes(airline)">
        <a-button type="primary" :disabled="!hasSelected" @click="certain">
          {{ `${isCertain ? '取消' : '确认'}选择` }}
        </a-button>
      </div>
      <div class="invoice-book-form" v-if="isCertain">
        <a-tabs :default-active-key="0" @change="tabChange">
          <a-tab-pane :key="0" tab="个人">
            <invoice-book-form
              :type="key"
              :initData="formData"
              @success="successMessage"
              :invoiceBookTips="invoiceBookTips"
            ></invoice-book-form>
          </a-tab-pane>
          <a-tab-pane :key="1" tab="企业">
            <invoice-book-form
              :type="key"
              :initData="formData"
              @success="successMessage"
              :invoiceBookTips="invoiceBookTips"
            ></invoice-book-form>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="succ" v-if="success">
        <p v-if="invoiceBookSuccess" v-html="invoiceBookSuccess"></p>
        <div class="back">
          <a-button type="primary" @click="goHome" >返回首页</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import Storage from '@/assets/js/storage'
import InvoiceBookForm from './components/form'
import { checkSmsCode, queryInvoiceList } from '@/apis/invoice'
import './index'

const columns = [
  {
    title: '订单号',
    dataIndex: 'orderNo',
    key: 'orderNo',
    align: 'center'
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName',
    align: 'center'
  },
  {
    title: '总价',
    dataIndex: 'orderAmount',
    key: 'orderAmount',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'orderAmount' }
  },
  {
    title: '购买日期',
    dataIndex: 'bookTime',
    key: 'bookTime',
    align: 'center'
  },
  {
    title: '开票状态',
    dataIndex: 'invoiceStatusName',
    key: 'invoiceStatusName',
    align: 'center'
  },
  {
    title: '订单详情',
    dataIndex: 'orderDetailUrl',
    key: 'orderDetailUrl',
    align: 'center',
    scopedSlots: { customRender: 'orderDetail' }
  },
  {
    title: '操作',
    key: 'actions',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  data () {
    return {
      columns,
      list: [],
      params: {},
      loading: true,
      selectedRowKeys: [],
      key: 0,
      isCertain: false,
      formData: {},
      success: false,
      invoiceBookTips: '',
      invoiceBookSuccess: '',
      airline: window.__MICRO_ROOT__?.airline || ''
    }
  },
  computed: {
    hasSelected () {
      return this.selectedRowKeys?.length > 0
    },
    rowSelection () {
      return {
        type: 'radio',
        getCheckboxProps: record => {
          return {
            props: {
              disabled: record.invoiceStatusName !== '可开具'
            }
          }
        },
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.onSelectChange(selectedRowKeys)
        }
      }
    }
  },
  created () {
    this.columns = columns.map(item => {
      if (!['Y8'].includes(this.airline) && item.key === 'actions') {
        item.className = 'table-col-hide'
      }
      return item
    })

    const params = Storage.getItem('ordersInvoiceParams')
    if (params) {
      this.params = JSON.parse(params)
      this.checkSmsCode()
    } else {
      this.$message.error('请输入查询信息')
    }
    this.getCmsData()
  },
  beforeDestroy () {
    Storage.removeItem('ordersInvoiceParams')
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then((res) => {
          const { invoiceBookTips, invoiceBookSuccess } = res
          this.invoiceBookTips = invoiceBookTips.content || ''
          this.invoiceBookSuccess = invoiceBookSuccess.content || ''
          this.cmsData = res
        })
      } catch (err) {}
    },
    async checkSmsCode () {
      try {
        const { phone, phoneCode: code } = this.params
        await checkSmsCode({
          phone,
          code
        }) && this.fetchInvoiceList()
      } catch (err) {
        this.$message.error(err.message || '验证失败，请稍后再试')
        this.$router.back()
        this.loading = false
      }
    },
    async fetchInvoiceList () {
      try {
        const res = await queryInvoiceList(this.params) || []
        const list = res.list ? res.list : res
        this.list = list.map((item, index) => {
          return { ...item, index }
        })
        this.loading = false
      } catch (err) {
        this.$message.error(err.message || '查询失败，请稍后再试')
        this.$router.back()
        this.loading = false
      }
    },
    detailLink (record) {
      const { productCode, orderId, orderNo } = record
      let url = '/'

      if (productCode === 'TICKET' && orderId) {
        url = `/order/v2/detail?orderId=${orderId}`
      } else if (orderNo) {
        url = `/ancillary/v2/detail?orderNo=${orderNo}`
      }

      return url
    },
    tabChange (key) {
      this.key = key
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.isCertain = false
      this.success = false
    },
    certain () {
      this.isCertain = !this.isCertain
      if (!this.isCertain) {
        this.selectedRowKeys = []
        return
      }
      const item = find(this.list, { index: this.selectedRowKeys[0] })

      this.formData = {
        extraId: item.extraId,
        orderNo: item.orderNo,
        project: item.productName,
        price: item.orderAmount || 0,
        detailId: item.detailId,
        airportTax: item.airportTax
      }
    },
    successMessage () {
      this.success = true
      this.isCertain = false
      this.selectedRowKeys = []
      this.fetchInvoiceList()
    },
    goThirdUrl (url) {
      if (url) {
        open(url, '_blank')
      } else {
        this.$message.error('开具电子发票地址缺失')
      }
    },
    goHome () {
      window.__MICRO_ROOT__?.router.push({ pathname: '/' })
    }
  },
  components: {
    InvoiceBookForm
  }
}
</script>

<style lang="less" scoped>
.invoice-book {
  .loading {
    width: 100%;
    text-align: center;
    margin-top: 50px;
  }
  .header {
    border-bottom: 1px solid @primary-color;
  }
  .invoice-book-flight {
    ::v-deep .table-col-hide {
      display: none;
    }
    .tips {
      color: #7f7f7f;
      text-align: left;
      margin-top: 10px;
      line-height: 30px;
    }
    .link {
      color: @primary-color;
      cursor: pointer;
    }
  }
  .mod-action {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  .invoice-book-form {
    padding: 70px 0;
    ::v-deep .ant-form-explain {
      margin-top: 0;
    }
    .invoice-wrap {
      padding: 70px 0;
      display: flex;
      .block {
        padding: 0 40px;
        width: 50%;
      }
      .invoice-form {
        border-right: 1px solid #eee;
      }
      .submit-btn.ant-btn {
        width: 100%;
      }
    }
  }
  .succ {
    margin-top: 20px;
    .back {
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>
